import { render, staticRenderFns } from "./NzPrivacyPolicyContent.vue?vue&type=template&id=7e5c09bf&scoped=true"
import script from "./NzPrivacyPolicyContent.vue?vue&type=script&lang=js"
export * from "./NzPrivacyPolicyContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5c09bf",
  null
  
)

export default component.exports